import React, { useEffect, useState } from 'react'
import AnimiatedPage from '../../AnimiatedPage'
import Contact from '../../Components/Contact/Contact'
import Works from '../../Components/Work/WorkPage'
import About from '../../Components/About/About'
import styles from "./Portfolio.module.css"
import { Document, Page, pdfjs, Pdf } from 'react-pdf';

import port from "../../assets/port.pdf"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
function Portfolio() {
  const [page, setPage] = useState(1);
  useEffect(() => {
    document.title = 'SHARVIL Business Group-Portfolio'
  }, [])
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <AnimiatedPage>
      <div className={styles.portfolio}>
        {/* <div className={styles.portfolioHead}>
                  <h1>OUR WORKS</h1>
                </div>
                <Works/>
                <About/>
                
                <Contact/> */}

        {/* <iframe src={`${port}`} rameborder="0" style={{ minHeight: "100vh", overflowY: "auto" }} type="application/pdf" width="100%" height="100vh"></iframe> */}
        <Document  onLoadProgress={()=>console.log("loading")} onLoadSuccess={onDocumentLoadSuccess} file={port}>
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
          ))}
        </Document>

      </div>
    </AnimiatedPage>
  )
}

export default Portfolio